import type { RefObject } from "react";

const HEADER_DESKTOP_HEIGHT = 64;

export default function scrollToRef(ref: RefObject<HTMLElement | null>) {
  setTimeout(() => {
    if (ref.current) {
      window.scrollTo(0, ref.current.offsetTop - HEADER_DESKTOP_HEIGHT);
    }
  }, 150);
}
